// extracted by mini-css-extract-plugin
module.exports = {"stack":"PlusButton_stack__tGwTn"};